@if (isLoading) {
	<mat-spinner mode="indeterminate" diameter="30" class="mx-a"></mat-spinner>
} @else {
	<form [formGroup]="formGroup">
		<app-card inCardTitle="Vehicle Detail"
				  icon="arrow_back"
				  [iconDisabled]="formGroup.pending || isSaving"
				  (iconClicked)="navigateBack()">
			@if (!isLoading) {
				<div *appCardContent>
					@if (saveError) {
						<mat-error>{{ saveError }}</mat-error>
					}
					<div>
						<app-vehicle-basic-information-edit formControlName="vehicle"
															[isImported]="isCartegraphIntegrationEnabled">
						</app-vehicle-basic-information-edit>
					</div>

					<div class="mt-spacing">
						@if(manualMaterialLogFeatureEnabled) {
							<div class="field-row">
								<div class="field-row-title">
									Manual Material Log
								</div>
								<div class="field-row-element">
									<mat-button-toggle-group formControlName="manualMaterialLog">
										<mat-button-toggle [value]="null">Inherit Default Settings</mat-button-toggle>
										<mat-button-toggle [value]="true">Yes</mat-button-toggle>
										<mat-button-toggle [value]="false">No</mat-button-toggle>
									</mat-button-toggle-group>
								</div>
							</div>
						}

						<app-row-with-toggle primaryText="PlowOps Pro"
											 secondaryText="Requires PlowOps Pro hardware kit"
											 formControlName="plowOpsPro">
						</app-row-with-toggle>
					</div>
					@if (formGroup.controls.plowOpsPro.value) {
						<app-vehicle-control-unit
								[vehicleId]="vehicle.id"
								formControlName="vehicleControlUnit"
								(vehicleChanged)="onVehicleChanged($event)">
						</app-vehicle-control-unit>
					}
				</div>
			}
		</app-card>
	</form>
}
